export const workshopsList = [
    {
        id: 1,
        name: 'ARDUINO USING TINKERCAD',
        cname: 'arduino',
    }
];